module.exports = __webpack_public_path__ + "img/Logo.6ac52cd2.svg";